import React, { memo, useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { withAuth } from '../AuthContext'
import styled from 'styled-components'

const NavSpacer = styled.div`
  width: 100%;
  height: 40px;

  @media screen and (max-width: 799px) {
    flex-direction: column;
  }
`

const NavContainer = styled.div`
  width: 100%;
  padding: 26px 40px;
`

const NavBar = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
  background-color: #51425b;
  border-radius: 24px;
  padding: 20px;
  width: 100%;

  @media screen and (max-width: 950px) {
    flex-direction: column;
  }
`

const NavButton = styled.div`
  ${(props) => props.color && `background-color: ${props.color}`};
  flex-basis: 33.33%;
  border-radius: 18px;
  color: #fff;
  padding: 12px 21px;
  margin: 0;
  text-align: right;
  position: relative;
  line-height: 140%;
  cursor: pointer !important;

  p {
    cursor: inherit;
    color: #fff;
    font-family: 'open-sans', sans-serif;
    font-size: 16px;
    font-weight: 400;
  }

  img {
    cursor: inherit;
  }

  @media screen and (max-width: 1070px) {
    font-size: 12px;
    padding: 17px 21px;
  }

  @media screen and (max-width: 950px) {
    font-size: 16px;
    padding: 24px 21px;
    width: webkit-fill-available;
    br {
      display: none;
    }
  }

  @media screen and (max-width: 430px) {
    font-size: 12px;
  }
`

const NavButtonIcon = styled.img`
  width: 50px;
  height: 50px;

  position: absolute;
  top: 10px;
  left: 14px;
`

const MyFreebirdNavBar = memo(({ user, promoPanelStep }) => {
  const [showNavBar, setShowNavBar] = useState(false)

  useEffect(() => {
    if (
      promoPanelStep !== 'photo' &&
      promoPanelStep !== 'email' &&
      promoPanelStep !== 'emailconf' &&
      promoPanelStep !== 'profile' &&
      promoPanelStep !== 'fee' &&
      promoPanelStep !== 'feestage2'
    ) {
      setShowNavBar(true)
    } else {
      setShowNavBar(false)
    }
  }, [promoPanelStep])

  const loadPage = (e, pageVal) => {
    e.preventDefault()
    window.open(pageVal, '_self')
  }

  const NavElement = ({ user }) => {
    if (showNavBar) {
      return (
        <NavContainer>
          <NavBar>
            <NavButton
              color="#62aa97"
              type="submit"
              padding="10px 60px"
              margin="40px 20px 0"
              fontsizesm="16px"
              onClick={(e) => loadPage(e, '/dashboard/community2')}
            >
              <NavButtonIcon
                src={'/images/profile/icon-community.png'}
                alt="community"
              />
              ENTER
              <br />
              &nbsp;COMMUNITY
            </NavButton>

            <NavButton
              color="#7780cd"
              type="submit"
              padding="10px 60px"
              margin="40px 20px 0"
              fontsizesm="16px"
              onClick={(e) => loadPage(e, '/search?seeking=locals')}
            >
              <NavButtonIcon
                src={'/images/profile/icon-locals.png'}
                alt="locals"
              />
              FIND
              <br />
              &nbsp;LOCALS
            </NavButton>
            <NavButton
              color="#7780cd"
              type="submit"
              padding="10px 60px"
              margin="40px 20px 0"
              fontsizesm="16px"
              onClick={(e) => loadPage(e, '/search?seeking=homestays')}
            >
              <NavButtonIcon
                src={'/images/profile/icon-homestays.png'}
                alt="homestays"
              />
              FIND
              <br />
              &nbsp;HOMESTAYS
            </NavButton>
            {user.status === 'approvedfinal' &&
            user.fbc_core_places.length > 0 ? (
              <NavButton
                color="#7780cd"
                type="submit"
                padding="10px 60px"
                margin="40px 20px 0"
                fontsizesm="16px"
                onClick={(e) => loadPage(e, '/dashboard/edit-place')}
              >
                <NavButtonIcon
                  src={'/images/profile/icon-host.png'}
                  alt="hosts"
                />
                MANAGE
                <br />
                &nbsp;HOMESTAYS
              </NavButton>
            ) : user.status === 'approvedfinal' &&
              user.fbc_core_places.length === 0 ? (
              <NavButton
                color="#7780cd"
                type="submit"
                padding="10px 60px"
                margin="40px 20px 0"
                fontsizesm="16px"
                onClick={(e) => loadPage(e, '/dashboard/edit-place')}
              >
                <NavButtonIcon
                  src={'/images/profile/icon-host.png'}
                  alt="hosts"
                />
                BECOME A
                <br />
                &nbsp;HOMESTAY HOST
              </NavButton>
            ) : null}
          </NavBar>
        </NavContainer>
      )
    } else {
      return <NavSpacer />
    }
  }

  if (!user) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border homestays-spinner"
          style={{ margin: '100px auto 100px', opacity: '0.3' }}
          role="status"
        ></div>
      </div>
    )
  }
  return <NavElement user={user} />
})

export default withRouter(withAuth(MyFreebirdNavBar))
